import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import axiosInstance from "../../../utils/axiosInstance";
import { isMobile } from "react-device-detect";
import Volume from "./Volume";
//import Teenpattit20Result from "../../client/tp-studio/tp-result/Teenpattit20-Result.jsx";
import RpsResult from "./tp-result/RpsResult.jsx";
//import TpRules from "./pop-up/tp-rules.jsx";
import RPSRules from "./pop-up/rps-rules.jsx";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

import rock from "../../../assets/topstudio/images/rockpaper/P2-Rock.png";
import paper from "../../../assets/topstudio/images/rockpaper/P2-Paper.png";
import scissor from "../../../assets/topstudio/images/rockpaper/P2-Scissor.png";
import rpsbg from "../../../assets/topstudio/images/rockpaper/RPSBG.png";

import "../../../assets/topstudio/styles/CardsSprite.css";
import "../../../assets/topstudio/styles/common.css";

export default function RockPapper() {
  const dispatch = useDispatch();

  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);
  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [pairAVal, setPairAVal] = useState(0);
  const [pairBVal, setPairBVal] = useState(0);
  const [isSuspended, setIsSuspended] = useState(true);
  const [suspendedText, setSuspendedText] = useState("SUSPENDED !");
  const [lastStatus, setLastStatus] = useState(null);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [resultList, setResultList] = useState([]);
  const [roundId, setRoundId] = useState("");
  const [winnerA, setWinnerA] = useState(false);
  const [winnerB, setWinnerB] = useState(false);
  const [winnerC, setWinnerC] = useState(false);

  const [playerABook, setPlayerABook] = useState(0);
  const [playerBBook, setPlayerBBook] = useState(0);
  const [playerCBook, setPlayerCBook] = useState(0);

  const [playerAPlusBook, setPlayerAPlusBook] = useState(0);
  const [playerBPlusBook, setPlayerBPlusBook] = useState(0);
  const [activeTabIndex, setActiveTabIndex] = useState(1);

  const [rpcCount, setrpcCount] = useState(15);
  const [GameState, setgameState] = useState("count");
  const [winText, setwinText] = useState("");
  const [resultImg, setresultImg] = useState(rock);
  const [shakeClass, setShakeClass] = useState("");
  const lastRoundRef = useRef(null);

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "RockPaperScissor_virtual"
  });
  const payload = data?.data?.data;
  //console.log("RPS socket", payload);
  
  const payloadResult = data?.data?.result;
  if (payload?.result) {
    //console.log("payloadResult: ", payload.result);
  }

  useEffect(() => {
    if (GameState !== "count") return;

    if (rpcCount == 0) {
      setgameState("shake");
      return;
    }
    const interval = setInterval(() => {
      setrpcCount((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [rpcCount, GameState]);

  // add near your other imports/states
  const CHOICES = [
    { src: rock, title: "Rock Wins !" },
    { src: paper, title: "Paper Wins !" },
    { src: scissor, title: "Scissor Wins !" }
  ];
  const lastIdxRef = useRef(-1);

  // random picker (avoids immediate repeat)
  function pickRandomIndex() {
    let idx = Math.floor(Math.random() * CHOICES.length);
    if (CHOICES.length > 1) {
      while (idx === lastIdxRef.current) {
        idx = Math.floor(Math.random() * CHOICES.length);
      }
    }
    lastIdxRef.current = idx;
    return idx;
  }

  useEffect(() => {
    if (GameState !== "shake") return;
    setShakeClass("rps-bob");
    const id = setTimeout(() => {
      setgameState("play");
    }, 3000);
    return () => clearTimeout(id);
  }, [GameState]);

  // after countdown ends, pick winner from payload.result (1=rock, 2=paper, 3=scissor)
  // Re-runs when result arrives so the reveal aligns with the round.
  useEffect(() => {
    if (GameState !== "play") return;

    const r = parseInt(payload?.result, 10);
    if (!(r >= 1 && r <= CHOICES.length)) {
      // No result yet — keep shaking until the server provides one.
      setShakeClass("rps-bob");
      setresultImg(rock);
      setwinText("");
      return;
    }

    const i = r - 1;
    lastIdxRef.current = i;
    setresultImg(CHOICES[i].src);
    setwinText(CHOICES[i].title);
    //setShakeClass("rps-bob"); // keep the animation running while revealing
    setShakeClass(""); // keep the animation running while revealing

    if (payload?.result == 1) {
      setWinnerA(true);
      setWinnerB(false);
      setWinnerC(false);
    } else if (payload?.result == 2) {
      setWinnerA(false);
      setWinnerB(true);
      setWinnerC(false);
    } else if (payload?.result == 3) {
      setWinnerA(false);
      setWinnerB(false);
      setWinnerC(true);
    }
  }, [GameState, payload?.result]);

  const [resultData, setResultData] = useState([]);

  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= FLIP STATE ================= */
  const [flipStep, setFlipStep] = useState(0);
  const flipTimerRef = useRef(null);
  const lastEvtStatusRef = useRef(null);

  const sessionUser = useSelector((s) => s.userStore.data);

  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  /* ================= DISPLAYED CARDS (IMPORTANT) ================= */
  const [shownCards, setShownCards] = useState({
    ac1: "1",
    ac2: "1",
    ac3: "1",
    bc1: "1",
    bc2: "1",
    bc3: "1"
  });

  const [shownCards1, setShownCards1] = useState({
    ac1: "1",
    ac2: "1",
    ac3: "1"
  });

  const [shownCards2, setShownCards2] = useState({
    bc1: "1",
    bc2: "1",
    bc3: "1"
  });

  const [displayLoader, setDisplayLoader] = useState(true);

  const displayRunnerName = (runnerName) => {
    if (!runnerName) return "";
    const key = String(runnerName).toLowerCase();
    if (key === "rock") return "Rock";
    if (key === "paper") return "Paper";
    if (key === "scissor" || key === "scissors") return "Scissor";
    return runnerName;
  };

  /// place bet ///

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  /* ================= TIMER SYNC ================= */
  useEffect(() => {
    if (!payload) return;
    updateUserData(data?.user);
    setDisplayLoader(false);

    if (lastStatus != payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]); //clearing placed bets on status change
      setWinnerA(false);
      setWinnerB(false);
      setWinnerC(false);

      setPlayerABook(0);
      setPlayerBBook(0);
      setPlayerCBook(0);
      setresultImg(rock);
    }

    // Restart the count -> shake -> play animation for every new round.
    if (payload?.cat_mid && lastRoundRef.current !== payload.cat_mid) {
      lastRoundRef.current = payload.cat_mid;
      setresultImg(rock);
      setwinText("");
      setShakeClass("");
      setrpcCount(15);
      setgameState("count");
    }
    if (lastStatus != payload.evt_status) {
      setLastStatus(payload.evt_status);
    }
    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds !== "number") return;

    setB1Val(payload?.b1);
    setB2Val(payload?.b2);
    setPairAVal(payload?.pairA);
    setPairBVal(payload?.pairB);
    setTimeLeft(serverSeconds);
    setRoundId(payload?.cat_mid);

    if (payload?.left_time >= 15 && payload?.left_time <= 30) {
      //displaying suspended
      setSuspendedText("NEXT ROUND !");
      setIsSuspended(true);
      setShowBetSlipPopup(false);
    } else {
      //hiding suspended
      setSuspendedText("SUSPENDED !");
      setIsSuspended(false);
    }

    if (
      payload?.suspend1 === 1 ||
      payload?.suspend2 === 1 ||
      payload?.suspend3 === 1 ||
      payload?.suspend4 === 1
    ) {
      setIsSuspended(true);
    }

    /*
    if (payload?.result == 1) {
      setWinnerA(true);
      setWinnerB(false);
      setWinnerC(false);
    } else if (payload?.result == 2) {
      setWinnerA(false);
      setWinnerB(true);
      setWinnerC(false);
    } else if (payload?.result == 3) {
      setWinnerA(false);
      setWinnerB(false);
      setWinnerC(true);
    }*/

    clearInterval(localTimerRef.current);

    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "rps_virtual"
    });
    let books = res?.data;
    if (books !== null && books.length > 0) {
      for (let i = 0; i < books.length; i++) {
        let obj = books[i];

        setPlayerABook(obj.Rock);
        setPlayerBBook(obj.Paper);
        setPlayerCBook(obj.Scissor);
      }
    }
  }

  useEffect(() => () => clearInterval(localTimerRef.current), []);

  /* ================= FLIP SEQUENCE ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;

    if (lastEvtStatusRef.current === payload.evt_status) return;

    lastEvtStatusRef.current = payload.evt_status;

    clearTimeout(flipTimerRef.current);
    setFlipStep(0);

    let step = 0;

    /*
    function run() {
      
      if (step >= sequence.length) return;

      const { key, value } = sequence[step];

      // start flip
      setFlipStep(step + 1);

      // swap card exactly at mid-flip
      setTimeout(() => {
        setShownCards((prev) => ({
          ...prev,
          [key]: value && value !== "1" ? value : "1",
        }));
      }, 300); // half of 600ms animation

      step++;
      flipTimerRef.current = setTimeout(run, 600);
    }*/

    function run() {
      // Steps 1–3 → Player A cards
      if (step >= 1 && step <= 3) {
        const key = `ac${step}`;

        setShownCards1((prev) => ({
          ...prev,
          [key]: payload?.[key]
        }));
      }

      // Steps 4–6 → Player B cards
      if (step >= 4 && step <= 6) {
        const cardIndex = step - 3; // 4→1, 5→2, 6→3
        const key = `bc${cardIndex}`;

        setShownCards2((prev) => ({
          ...prev,
          [key]: payload?.[key]
        }));
      }

      //setFlipStep((prev) => prev + 1);
      setFlipStep(step + 1);
      step++;

      if (step <= 6) {
        flipTimerRef.current = setTimeout(run, 400);
      }
    }

    //checking here for first time

    flipTimerRef.current = setTimeout(run, 1500);

    return () => clearTimeout(flipTimerRef.current);
  }, [payload?.evt_status]);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  const showBetfairBetSlip = (bettype, teamname, selectRnr, price) => {
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "rock_paper_scissor"
    };
    placeBetObject.catmid = payload?.cat_mid;
    placeBetObject.round = payload?.cat_mid;

    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = 1;
    placeBetObject.game_type = 7;

    setPlaceBetObject(placeBetObject);
    //console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };

  /// place bet ///
  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const closeBetSlip = () => {
    setShowBetSlip(false);
  };
  const [profileData, setProfileData] = useState(null);

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      //console.log("Failed to load profile data:", error);
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      //console.log("Bet stake limit", data);
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit??data?.myBetLimit?.figure));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  const [initialBetsFetched, setInitialBetsFetched] = useState(false);
  const [placedBets, setPlacedBets] = useState([]);

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "rock_paper_scissor"
    });
    setPlacedBets(res.data);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      setInitialBetsFetched(true);
      getBook();
    }
  }, [payload]);

  const getCardImage = (cardValue, reveal) => {
    return reveal && cardValue && cardValue !== "1" ? cardValue : "1";
  };

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "RockPaperScissor_virtual";

    //console.log("BEFORE API CALL");

    const response = await axiosInstance.post("/teenpatti-results", resultObj);
    //console.log("FULL RESPONSE", response.data);
    //console.log("AFTER API CALL");

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };

  /*const showResultDetail = async () => {
    try {
      let resultObj = {};
      resultObj.game_type = "tp20_virtual";

      console.log("BEFORE API CALL");

      const response = await axiosInstance.post(
        "/teenpatti-results",
        resultObj
      );

      console.log("FULL RESPONSE", response.data);
    } catch (err) {
      console.log("RPS ERROR", err);
      console.log("RPS RESPONSE", err?.response?.data);
    }
  };*/

  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <>
      {shownCards && (
        <div className="aviator-scope player-scope aviator-bg-black">
          <ClientLayoutWithOutHeader showLoader={false}>
            <div class="details-tabs-wrapper1">
              <div className="main-page">
                <div className="row no-gutters">
                  <div className="col-md-12">
                    <div className="bodyheight">
                      <div className="wrapper">
                        <TPStudioSidebar open={open} />
                      </div>

                      <div className="lobby-ctn BPGmaindiv">
                        <TpStudioHeader setOpen={setOpen} open={open} />
                        <TpStudioLoader displayLoader={displayLoader} />
                      </div>

                      <div
                        className="row"
                        style={{ display: displayLoader ? "none" : "" }}
                      >
                        <div className="col-md-8">
                          <div className="left-content">
                            <div>
                              <div>
                                <div
                                  className="col-12 timerDiv2"
                                  style={{ marginBottom: "-24px" }}
                                >
                                  <div
                                    className="footer-divbpg border-gradient-footer border-gradient-purple-footer"
                                    style={{ height: "45px" }}
                                  >
                                    <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                                      <p
                                        style={{
                                          fontSize: isMobile ? "16px" : "17px"
                                        }}
                                      >
                                        ROCK PAPER SCISSOR
                                      </p>
                                    </div>
                                    <div
                                      className="col-6 col-md-6 inline-block Gameidcol text-right"
                                      style={{ marginTop: "2px" }}
                                    >
                                      <div
                                        role="group"
                                        aria-label="Second group"
                                        className="btn-group btn-group-sm mr-2"
                                      >
                                        <button
                                          style={{ fontSize: "14px" }}
                                          type="button"
                                          id="Alltab"
                                          className={
                                            activeTabIndex == 1
                                              ? "tablink btn btn-primary bbactive"
                                              : "tablink btn btn-primary"
                                          }
                                          onClick={() => activeTab(1)}
                                        >
                                          Game
                                        </button>
                                        <button
                                          style={{ fontSize: "14px" }}
                                          type="button"
                                          id="RESULTStab"
                                          className={
                                            activeTabIndex == 2
                                              ? "tablink btn btn-primary bbactive"
                                              : "tablink btn btn-primary"
                                          }
                                          onClick={() => activeTab(2)}
                                        >
                                          Results
                                        </button>
                                        <button
                                          style={{ fontSize: "14px" }}
                                          type="button"
                                          className="tablink btn btn-primary"
                                          onClick={() => setShowRules(true)}
                                        >
                                          Rules
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    className="row mt-2 rps-bettor-row"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    <div className="col-2 col-md-1">
                                      <div className="Connectedclients mt-1">
                                        <i
                                          aria-hidden="true"
                                          className="fa fa-user mr-1"
                                          style={{
                                            fontSize: "14px",
                                            color: "white"
                                          }}
                                        />
                                        <b>
                                          <span
                                            id="UsersCount"
                                            className="number"
                                          >
                                            326
                                          </span>
                                        </b>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div
                                  className="cards-layout blackjack"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div
                                    style={{
                                      display:
                                        activeTabIndex == 1 ? "" : "none",
                                      textAlign: "right",
                                      marginRight: "0px"
                                    }}
                                    className="volume-wrapper"
                                  >
                                    <div
                                      className="rpc-container"
                                      style={{
                                        position: "relative",
                                        height: isMobile ? "300px" : "450px"
                                      }}
                                    >
                                      <img
                                        className="cover-img"
                                        src={rpsbg}
                                        alt=""
                                        style={{ borderRadius: "0px" }}
                                      />

                                      <div className="rpc-content d-flex justify-content-center align-items-center">
                                        {GameState == "count" && (
                                          <div className="rpc-overlay glass d-flex justify-content-center align-items-center ">
                                            <h2 className="rpc-counter">
                                              Starting in {rpcCount}
                                            </h2>
                                          </div>
                                        )}

                                        <div className="hand-container">
                                          {(winText ||
                                            GameState === "shake" ||
                                            GameState === "play") && (
                                            <>
                                              <img
                                                src={resultImg}
                                                alt=""
                                                style={{
                                                  width: "160px",
                                                  height: `150px`
                                                }}
                                                className={shakeClass}
                                              />
                                              {winText && (
                                                <h4
                                                  className="text-center rps-win-text"
                                                  style={{ fontWeight: `bold` }}
                                                >
                                                  {winText}
                                                </h4>
                                              )}
                                            </>
                                          )}
                                          {GameState == "count" ? (
                                            <img
                                              src={resultImg}
                                              alt=""
                                              style={{
                                                width: "160px",
                                                height: `150px`
                                              }}
                                              className={shakeClass}
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                      <Volume
                                        id="RpsSoundcontrol"
                                        style={{
                                          position: "absolute",
                                          right: 8,
                                          bottom: 8,
                                          zIndex: 100
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Footer */}
                            <center
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div
                                className="footer-divbpg border-gradient-footer border-gradient-purple-footer"
                                style={{ marginTop: "0px" }}
                              >
                                <div className="buttons-div">
                                  {Object.keys(resultList).map((idx, index) =>
                                    index < 10 ? (
                                      <button
                                        key={idx}
                                        className="video-button border-gradient-btn border-gradient-purple-btn"
                                      >
                                        {resultList[idx]}
                                      </button>
                                    ) : (
                                      ""
                                    )
                                  )}
                                </div>
                                <div className="round-div">
                                  <div className="label">Round ID:</div>
                                  <div className="id">{payload?.cat_mid}</div>
                                </div>
                              </div>
                            </center>

                            {/* Market Sections (unchanged) */}
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div
                                className="tb-content"
                                style={{ background: "#fff" }}
                              >
                                <div className="market-titlebar">
                                  <p className="market-name">
                                    <span className="market-name-badge">
                                      <i className="market-name-icon">
                                        <img
                                          src="/assets/images/time-img.png"
                                          style={{
                                            filter: "invert(100%)",
                                            marginTop: "-8px",
                                            marginLeft: "-1px"
                                          }}
                                        />
                                      </i>
                                      <span>MAIN </span>
                                      {/*-<span style="text-transform: initial;">
                                                          (MaxBet: 5M) </span></span> <span class="rules-badge"><i class="fa fa-info-circle"></i></span>-*/}
                                    </span>
                                  </p>
                                  <div className="market-overarround">
                                    <span />
                                    <strong>Back</strong>
                                  </div>
                                  <div className="market-overarround market-overarround-lay">
                                    <strong>Lay</strong>
                                  </div>
                                </div>
                                <div className="market-runners">
                                  <div
                                    className="runner-runner"
                                    style={{ height: "auto" }}
                                  >
                                    <h3
                                      className={
                                        winnerA
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                      id="b1Sucess"
                                    >
                                      <div className="runner-info">
                                        <span className="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: 0,
                                                      fontWeight: "bold",
                                                      fontSize: "16px"
                                                    }}
                                                    className="clippable-spacer"
                                                  >
                                                    Rock
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus1"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        playerABook !== 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        playerABook > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(
                                                      playerABook
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>
                                    <div className="price-row-box-new">
                                      {isSuspended && (
                                        <div
                                          className="runner-disabled2"
                                          id="suspendCls1"
                                        >
                                          SUSPENDED !
                                        </div>
                                      )}
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a
                                        className="price-price price-back mb-show span1details"
                                        id="runner1b1span"
                                        data-teamname="Rock"
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "rock",
                                            "rock",
                                            b1Val
                                          )
                                        }
                                      >
                                        {b1Val}
                                        <span
                                          className="price-amount"
                                          id="rate1"
                                        >
                                          {stakeLimit}
                                        </span>
                                      </a>
                                      <a className="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                  <div
                                    className="runner-runner"
                                    style={{ height: "auto" }}
                                  >
                                    <h3
                                      className={
                                        winnerB
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                      id="b2Sucess"
                                    >
                                      <div className="runner-info">
                                        <span className="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: 0,
                                                      fontWeight: "bold",
                                                      fontSize: "16px"
                                                    }}
                                                    className="clippable-spacer"
                                                  >
                                                    Paper
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus2"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        playerBBook !== 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        playerBBook > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(
                                                      playerBBook
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>
                                    <div className="price-row-box-new">
                                      {isSuspended && (
                                        <div
                                          className="runner-disabled2"
                                          id="suspendCls1"
                                        >
                                          SUSPENDED !
                                        </div>
                                      )}
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a
                                        className="price-price price-back mb-show span1details"
                                        id="runner1b2span"
                                        data-teamname="Paper"
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "paper",
                                            "paper",
                                            b2Val
                                          )
                                        }
                                      >
                                        {b2Val}
                                        <span
                                          className="price-amount"
                                          id="rate1"
                                        >
                                          {stakeLimit}
                                        </span>
                                      </a>
                                      <a className="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>

                                  <div
                                    className="runner-runner"
                                    style={{ height: "auto" }}
                                  >
                                    <h3
                                      className={
                                        winnerC
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                      id="b3Sucess"
                                    >
                                      <div className="runner-info">
                                        <span className="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: 0,
                                                      fontWeight: "bold",
                                                      fontSize: "16px"
                                                    }}
                                                    className="clippable-spacer"
                                                  >
                                                    Scissor
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus2"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        playerCBook !== 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        playerCBook > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(
                                                      playerCBook
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>
                                    <div className="price-row-box-new">
                                      {isSuspended && (
                                        <div
                                          className="runner-disabled2"
                                          id="suspendCls1"
                                        >
                                          SUSPENDED !
                                        </div>
                                      )}
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a
                                        className="price-price price-back mb-show span1details"
                                        id="runner1b2span"
                                        data-teamname="Scissor"
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "scissor",
                                            "scissor",
                                            b2Val
                                          )
                                        }
                                      >
                                        {b2Val}
                                        <span
                                          className="price-amount"
                                          id="rate1"
                                        >
                                          {stakeLimit}
                                        </span>
                                      </a>
                                      <a className="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style={{ height: "5px" }}></div>
                          </div>

                          <div
                            style={{
                              display: activeTabIndex == 2 ? "" : "none",
                              color: "white"
                            }}
                          >
                            <RpsResult resultData={resultData} />
                          </div>
                        </div>

                        <div className="col-md-4">
                          {showBetSlipPopup && (
                            <TPPopUpBetSlip
                              closeBetSlipParent={closeBetSlipMobile}
                              betObj={placeBetObject}
                              placeBetParent={placeBet}
                              betButtonShow={betButtonShow}
                              betErrorMessageObj={betErrorMessageObj}
                              betButtonShowLoaderShow={betButtonShowLoaderShow}
                              profileData={profileData}
                            />
                          )}

                          <TeenPattisCasinoBetslipWeb
                            showBetSlip={showBetSlip}
                            placeBetObject={placeBetObject}
                            closeBetSlipParent={closeBetSlip}
                            placeBetParent={placeBet}
                            betErrorMessageObj={betErrorMessageObj}
                            profileData={profileData}
                          ></TeenPattisCasinoBetslipWeb>
                          <div>
                            <div className="bets">
                              <strong style={{ fontSize: "16px" }}>
                                Matched Bets ({placedBets.length})
                                <img
                                  src={reconnecting}
                                  alt="dc"
                                  className="rounded disconnected"
                                  style={{ display: "none" }}
                                />{" "}
                              </strong>
                              <div className="betting-table">
                                <table className="table">
                                  <thead>
                                    <tr style={{ fontSize: "16px" }}>
                                      <th>Runner</th>
                                      <th>Price</th>
                                      <th>Size</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {placedBets.map((bet, index) => {
                                      console.log("MATCHED BET:", bet);
                                      return (
                                        <tr
                                          key={index}
                                          style={{
                                            background:
                                              bet.type == "b"
                                                ? "#e9f6fc"
                                                : "#fce3e4"
                                          }}
                                        >
                                          <td>
                                            {displayRunnerName(bet.rnr)} - (
                                            {bet.cat_mid})
                                          </td>
                                          <td>{bet.amnt}</td>
                                          <td>{bet.rate}</td>
                                          <td></td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <RPSRules show={showRules} onClose={() => setShowRules(false)} />
          </ClientLayoutWithOutHeader>

          <style>
            {`

.rpc-container {
  height: 450px;
}

.tb-content{
  padding-top:3px;
}

/* ---------------- DESKTOP ---------------- */

@media (min-width:992px){

  .table-player{
    font-size:60px !important;
  }

  .table-player .player-name{
    font-size:13px;
  }

  .market-titlebar .market-name-badge span,
  .market-titlebar .market-overarround strong,
  .market-titlebar .market-overarround-lay strong{
    font-size:14px;
  }

  .aviator-scope .row{
    margin-left:0 !important;
    margin-right:0 !important;
  }

  .col-md-8{
    padding-left:19px !important;
    margin-bottom:9px;
  }

  .left-content{
    padding-right:6px;
  }
      .aviator-scope .col-12{
    padding-left:0 !important;
    padding-right:0 !important;
  }

  .left-content .market-titlebar {
    width: 100%;
    display: flex;
    height: 20px;
}

.runner-runner .lobby-btn {
   height: 38px !important;
   min-height: 38px !important;
   padding: 2px 4px !important;
}

.cards-layout.blackjack {
   min-height: 210px;
}
.volume-wrapper {
   margin-top: -35px;
}
  

}

/* ---------------- MOBILE---------------- */

@media (max-width:991px){

  .table-player{
    font-size:16px !important;
  }

  .market-titlebar strong{
    font-size:13px;
  }

  .col-md-8{
    padding-left:15px !important;
  }

  .left-content{
    padding-right:0;
  }

}
 @media (max-width:576px){
  .footer-divbpg{
    display:flex;
    align-items:center;
    justify-content:space-between;
    flex-wrap:nowrap; 
    border-radius:8px;
  }
    .aviator-scope .col-12{
    padding-left:0 !important;
    padding-right:0 !important;
  }
  .titlebarname p{
    font-size:18px;
  }
    .player-scope .table-player {
      justify-content: center; 
      gap: 1px !important;  
      padding: 0 24px !important;         
   }
  .btn-group-sm .btn{
    padding:2px 6px;
    font-size:12px;
  }
  .btn-group{
    flex-wrap:nowrap !important;
  }
    .footer-divbpg .btn-group-sm .btn{
    padding:6px 4px !important;
    font-size:12px !important;
    line-height:1.2;
    margin-top: 0;
  }
  .footer-divbpg .titlebarname{
    flex:1;         
    max-width:none !important;
    padding-left:4px;
  }
  .titlebarname p{
    font-size:17px;
    margin:0;
    margin-bottom: 12px;
    margin-left: 18px;
  }
    .player-scope .table-player{
    justify-content:space-between;
    gap:6px;
    padding:0 10px;
  }
  .tp20-player{
    width:48% !important;  
  }
  .tp20-hand{
    width:100% !important;
  }
  @scope (.aviator-scope) {
    .video-button {
      padding: 0px;
      background-color: #4f4f4f;
      color: #fff;
      font-family: Montserrat-ExtraBold;
      font-size: 12px !important;
      font-style: normal;
      font-weight: 500;
      height: 35px !important;
      margin-right: 3px;
      text-align: center;
      width: 1px !important;
      max-width: auto;
    }
  }
}
  @media (max-width: 768px) {

   .cards-layout.blackjack {
      min-height: 175px !important;
   }

   .timerDiv2 {
      margin-bottom: 0 !important;
   }

   .footer-divbpg {
      margin-top: 0 !important;
   }

   .volume-wrapper {   /* we will add this class below */
      margin-top: 0 !important;
   }
}

.aviator-scope .timerDiv2 .Connectedclients {
  position: relative;
  top: -5px;
  left: -3px;
}

@media (max-width: 768px) {
  .aviator-scope .timerDiv2 {
    position: relative;
  }

  .aviator-scope .rps-bettor-row {
    position: absolute;
    top: 100%;
    left: 18px;
    margin-top: 8px !important;
    z-index: 100;
    width: auto;
  }

  .aviator-scope .rps-bettor-row .col-2 {
    width: auto !important;
    max-width: none !important;
    flex: 0 0 auto !important;
    padding: 0 !important;
  }

  .aviator-scope .rps-bettor-row .Connectedclients {
    position: absolute;
    top: 0;
    left: 0;
    margin-top: 0 !important;
  }
}

@media (max-width: 576px) {
  .aviator-scope .rps-bettor-row {
    left: 19px;
    margin-top: 6px !important;
  }
}

.rps-win-text {
  color: #fff !important;
}
  
`}
          </style>
        </div>
      )}
    </>
  );
}
